import { useGiveawaySection } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection';
import twitchIcon from 'root/src/client/public/icons/ic-twitch-channel.svg';
import youtubeIcon from 'root/src/client/public/icons/ic-youtube-colorized.svg';
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
import { ActionStrategyId } from '@daredrop-com/rewards-api-contract';
import { useCreatorData } from 'root/src/client/logic/api/hooks/useCreatorData';
// actions hidden from list
const hiddenEntryStrategyIds = [
    // shown in giveaway section
    ActionStrategyId.EnterGiveaway,
    // shown in giveaway section
    ActionStrategyId.EnterGiveawaySteam,
    // handled separately
    ActionStrategyId.EnterGiveawayVerifySms,
];
const entryIcon = {
    [ActionStrategyId.EnterGiveawayTwitch]: twitchIcon,
    [ActionStrategyId.EnterGiveawayYoutube]: youtubeIcon,
    [ActionStrategyId.EnterGiveawayTwitchSubscription]: twitchIcon,
};
const entryLabel = {
    [ActionStrategyId.EnterGiveawayTwitch]: params => `Follow ${params.displayName} on Twitch`,
    [ActionStrategyId.EnterGiveawayYoutube]: params => `Subscribe ${params.displayName} on YouTube`,
    [ActionStrategyId.EnterGiveawayTwitchSubscription]: params => `Subscribe to ${params.displayName} on Twitch`,
};
const entryAction = {
    [ActionStrategyId.EnterGiveawayTwitch]: 'Follow',
    [ActionStrategyId.EnterGiveawayYoutube]: 'Subscribe',
    [ActionStrategyId.EnterGiveawayTwitchSubscription]: 'Subscribe',
};
export const useGiveawayEntries = () => {
    var _a;
    const { giveaway } = useGiveawaySection();
    const { authentication } = useAuthentication();
    const creatorData = useCreatorData();
    // refetch giveaways
    const entryLabelParams = {
        displayName: (creatorData === null || creatorData === void 0 ? void 0 : creatorData.displayName) || 'Creator',
    };
    const entries = ((_a = giveaway === null || giveaway === void 0 ? void 0 : giveaway.actions) === null || _a === void 0 ? void 0 : _a.map((action) => {
        var _a, _b;
        const strategy = action.strategyId;
        const label = ((_a = entryLabel[strategy]) === null || _a === void 0 ? void 0 : _a.call(entryLabel, entryLabelParams)) || '?';
        const actionName = entryAction[strategy];
        return {
            id: action.id,
            label,
            score: action.score,
            isDone: Boolean((_b = action.entries) === null || _b === void 0 ? void 0 : _b.length),
            icon: entryIcon[strategy] || null,
            strategyId: action.strategyId,
            actionName,
            isVisible: Boolean(entryAction[strategy]),
        };
    })) || [];
    const entriesList = entries.filter((entry) => {
        return !hiddenEntryStrategyIds.includes(entry.strategyId);
    });
    const isOwner = giveaway && authentication && (giveaway === null || giveaway === void 0 ? void 0 : giveaway.ownerId) === (authentication === null || authentication === void 0 ? void 0 : authentication.userId);
    return {
        entries,
        entriesList,
        isLogged: Boolean(authentication),
        isEntered: Boolean(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isEntered),
        isOwner: Boolean(isOwner),
    };
};
